import { invalidateItemQueries } from '@/shared/api/invalidate-item-queries';
import { trpc } from '@/shared/api/trpc';

export const useUpdateSupplierReference = () => {
  const utils = trpc.useUtils();
  return trpc.operations.updateSupplierReference.useMutation({
    onSettled: () => invalidateItemQueries(utils),
  });
};
